<template>
    <TableView
        :headers="[
            { text: 'Title', property: 'title', align: 'left', link: true },
            { text: 'Locale', property: 'locale', align: 'left' },
            { text: 'Created', property: 'created_time_ago', align: 'left' },
        ]"
        :dialog-text="{
            heading: 'Delete endpoint',
            body: 'Do you really want to delete this endpoint?',
        }"
        api-base="endpoints"
        url-base="/endpoints"
        heading="Endpoints"
    />
</template>

<script>
import TableView from '../../components/table/TableView.vue';

export default {
    components: {
        TableView,
    },
};
</script>
